/**
 * Capa de asistencia para la nueva generacion: el mismo partido, distinto
 * perdon.
 *
 * **El iman de direccion se quito el 2026-08-26.** Ningun nivel corrige ya
 * hacia donde va el balon: si apuntas mal, sale mal. Lo que queda es cuanto
 * te perdona el juego en la EJECUCION — el castigo por golpear cruzado a la
 * carrera (`spreadScale`) y lo que tardas en dominar un balon exigente
 * (`trapScale`).
 */
export type AssistLevel = "easy" | "normal" | "pro";

export interface AssistProfile {
  id: AssistLevel;
  label: string;
  blurb: string;
  /** Multiplicador del trapTime tras un primer toque exigente. */
  trapScale: number;
  /**
   * Multiplicador del castigo por golpear cruzado a la carrera. Con el iman
   * fuera, es la UNICA diferencia de precision entre niveles.
   */
  spreadScale: number;
  /** Reservado: el cambio es solo manual (Tab/Q). */
  autoSwitch: boolean;
  /** Mostrar radar. */
  radar: boolean;
}

export const ASSIST_LEVELS: readonly AssistLevel[] = ["easy", "normal", "pro"];

export const ASSIST_PROFILES: Record<AssistLevel, AssistProfile> = {
  easy: {
    id: "easy",
    label: "Facil",
    blurb: "Golpeo limpio aunque cruces la carrera. Ideal para entrar.",
    trapScale: 0.3,
    spreadScale: 0.3,
    autoSwitch: false,
    radar: true,
  },
  normal: {
    id: "normal",
    label: "Normal",
    blurb: "Te perdona algo el cuerpo mal puesto. Apuntas tu.",
    trapScale: 0.65,
    spreadScale: 0.62,
    autoSwitch: false,
    radar: true,
  },
  pro: {
    id: "pro",
    label: "Pro",
    blurb: "Cero perdon. Cambio manual. El techo de skill.",
    trapScale: 1,
    // Pro: sin ninguna ayuda.
    spreadScale: 1,
    autoSwitch: false,
    radar: true,
  },
};

export const DEFAULT_ASSIST: AssistLevel = "normal";
